// Slide menu
var slide = document.getElementById("slide__menu");
var slideMenu1Clone = "slide__menu-clone";
var slideMenuClone = document.getElementById(slideMenu1Clone);

function slideMenuState(state) {
    if (slide){
        slide.style.display = "none";
    } else {
        return;
    }

    if (state == 'mediaDesktop') {
        slide.style.display = "block";
        $('.slide__menu').dropDownMenu({
            disabled: true,
            classBtn: '',
            independent: false,
            overlay: false
        });
        $('.slide__menu').dropDownMenu({
            disabled: false,
            classBtn: 'button-1 button-1--no-icon button-1--svg',
            independent: false,
            overlay: true
        });


    } else if ((state == 'mediaSmartphone') || (state == "mediaTablet")) {
        if (slide) {
            slide.style.display = "none";
        }
        $('.slide__menu').dropDownMenu({
            disabled: true,
            classBtn: '',
            independent: false
        });
        $('.slide__menu').dropDownMenu({
            disabled: false,
            classBtn: '',
            independent: false
        });
    }
}


var cloneSlideMenu = function (media) {
    if (slide) {
        slide.style.display = "none";
    } else {
        return;
    }

    var slideCloned = slide.cloneNode(true);
    slideCloned.id = slideMenu1Clone;

    if (media == "mediaTablet") {
        var parentNode = document.getElementsByClassName("menu-main-1__sublevel");
        insertAfter(parentNode[0], slideCloned);
        slideCloned.style.display = "block";
    }
    if (media == "mediaSmartphone") {
        var parentNode2 = document.getElementById('search-clone')
        insertAfter(parentNode2, slideCloned);
        slideCloned.style.display = "block";
    }
}

